import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Snowflake, Loader2, Lock } from "lucide-react";
import Logo from "@/components/Logo";

const inputCls = "w-full bg-[#050810] border border-[#1A2642] text-white rounded-md px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#00B4D8] focus:border-transparent transition";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("climomax_admin_token", data.token);
      nav("/admin");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050810] frost-grid px-5">
      <form onSubmit={submit} className="glass border border-[#1A2642] rounded-lg p-8 w-full max-w-sm" data-testid="admin-login-form">
        <div className="mb-1">
          <Logo className="h-10 w-auto" />
        </div>
        <p className="text-[#94A3B8] text-sm mb-6 flex items-center gap-1.5"><Lock className="w-3.5 h-3.5" /> Espace gérant</p>
        {error && <div className="bg-[#EF476F]/15 border border-[#EF476F]/30 text-[#EF476F] text-sm rounded-md px-3 py-2 mb-4" data-testid="login-error">{error}</div>}
        <label className="block text-[11px] font-bold uppercase tracking-[0.18em] text-[#94A3B8] mb-2">Email</label>
        <input type="email" required className={inputCls} data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <label className="block text-[11px] font-bold uppercase tracking-[0.18em] text-[#94A3B8] mb-2 mt-4">Mot de passe</label>
        <input type="password" required className={inputCls} data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button type="submit" disabled={loading} data-testid="admin-login-btn"
          className="w-full mt-6 bg-[#00B4D8] text-[#050810] font-bold rounded-full py-3 hover:bg-[#90E0EF] disabled:opacity-50 transition flex items-center justify-center gap-2">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Se connecter
        </button>
        <a href="/" className="block text-center text-xs text-[#475569] hover:text-[#94A3B8] mt-5 transition">Retour au site</a>
      </form>
    </div>
  );
}
